(function () {
  var root = document.querySelector('[data-alma-cart]');
  if (!root) return;

  var state = {
    date: root.dataset.initDate || null,
    window: root.dataset.initWindow || null,
    method: root.dataset.initMethod || 'משלוח'
  };

  function setAttr(name, value) {
    var attrs = {};
    attrs[name] = value || '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function money(cents) {
    return '₪' + (cents / 100).toFixed(2);
  }

  function refreshTotals(cart) {
    var s = root.querySelector('[data-cart-subtotal]');
    var t = root.querySelector('[data-cart-total]');
    if (s) s.textContent = money(cart.items_subtotal_price);
    if (t) t.textContent = money(cart.total_price);
  }

  // Attribute fields
  root.querySelectorAll('[data-alma-attr]').forEach(function (el) {
    var name = el.getAttribute('data-alma-attr');
    var dt;
    el.addEventListener('input', function () {
      clearTimeout(dt);
      dt = setTimeout(function () { setAttr(name, el.value.trim()); }, 500);
    });
  });

  // Method radios
  root.querySelectorAll('[data-alma-method]').forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      state.method = r.value;
      root.querySelectorAll('.alma-cart__method').forEach(function (l) { l.classList.remove('is-active'); });
      r.closest('.alma-cart__method').classList.add('is-active');
      var addr = root.querySelector('[data-address-block]');
      if (addr) addr.hidden = r.value === 'איסוף';
      setAttr('שיטת קבלה', r.value);
    });
  });

  // Line items
  root.querySelectorAll('[data-qty-line]').forEach(function (wrap) {
    var key = wrap.getAttribute('data-qty-line');
    var input = wrap.querySelector('[data-qty-input]');
    function commit(q) {
      q = Math.max(0, parseInt(q, 10) || 0);
      input.value = q;
      changeLine(key, q).then(function (cart) {
        refreshTotals(cart);
        if (q === 0) setTimeout(function () { location.reload(); }, 200);
      });
    }
    wrap.querySelector('[data-qty-down]').addEventListener('click', function () { commit((parseInt(input.value, 10) || 1) - 1); });
    wrap.querySelector('[data-qty-up]').addEventListener('click', function () { commit((parseInt(input.value, 10) || 0) + 1); });
    input.addEventListener('change', function () { commit(input.value); });
  });

  root.querySelectorAll('[data-remove-line]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      changeLine(btn.getAttribute('data-remove-line'), 0).then(function () { location.reload(); });
    });
  });

  // ===== Time modal =====
  var modal = root.querySelector('[data-time-modal]');
  var saveBtn = modal.querySelector('[data-time-save]');
  var quickWrap = modal.querySelector('[data-quick-days]');
  var calWrap = modal.querySelector('[data-calendar]');
  var noticeEl = modal.querySelector('[data-modal-notice]');
  var bannerEl = modal.querySelector('[data-modal-date-banner]');
  var selectedIso = null;
  var selectedWindow = null;
  var HEB_DAYS = ['ראשון','שני','שלישי','רביעי','חמישי','שישי','שבת'];
  var HEB_MONTHS = ['ינואר','פברואר','מרץ','אפריל','מאי','יוני','יולי','אוגוסט','ספטמבר','אוקטובר','נובמבר','דצמבר'];

  function pad(n) { return n.toString().padStart(2, '0'); }
  function fmtHe(d) { return d.getDate() + '.' + pad(d.getMonth() + 1) + '.' + (d.getFullYear() % 100); }
  function fmtIso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fmtFull(d) { return 'יום ' + HEB_DAYS[d.getDay()] + ' ' + d.getDate() + ' ב' + HEB_MONTHS[d.getMonth()]; }

  function buildQuick() {
    quickWrap.innerHTML = '';
    var labels = ['להיום', 'למחר', 'מחרתיים'];
    for (var i = 0; i < 3; i++) {
      var d = new Date(); d.setDate(d.getDate() + i);
      var iso = fmtIso(d);
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'alma-time-modal__chip';
      chip.setAttribute('data-iso', iso);
      chip.innerHTML = '<span class="alma-time-modal__chip-label">' + labels[i] + '</span><span class="alma-time-modal__chip-sub">' + fmtHe(d) + '</span>';
      chip.addEventListener('click', function () { selectDate(this.getAttribute('data-iso')); });
      quickWrap.appendChild(chip);
    }
  }

  function buildCalendar() {
    calWrap.innerHTML = '';
    var head = document.createElement('div');
    head.className = 'alma-time-modal__cal-head';
    HEB_DAYS.forEach(function (n) { var c = document.createElement('span'); c.textContent = n.charAt(0); head.appendChild(c); });
    calWrap.appendChild(head);
    var grid = document.createElement('div');
    grid.className = 'alma-time-modal__cal-grid';
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var first = new Date(today); first.setDate(1);
    for (var p = 0; p < first.getDay(); p++) {
      var pd = document.createElement('span'); pd.className = 'alma-time-modal__cal-pad'; grid.appendChild(pd);
    }
    var max = new Date(today); max.setDate(today.getDate() + 35);
    var cur = new Date(first);
    while (cur <= max) {
      var cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'alma-time-modal__cal-cell';
      cell.textContent = cur.getDate();
      cell.setAttribute('data-iso', fmtIso(cur));
      if (cur < today) cell.disabled = true;
      cell.addEventListener('click', function () { selectDate(this.getAttribute('data-iso')); });
      grid.appendChild(cell);
      cur.setDate(cur.getDate() + 1);
    }
    calWrap.appendChild(grid);
  }

  function selectDate(iso) {
    selectedIso = iso;
    var p = iso.split('-');
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    bannerEl.textContent = fmtFull(d) + ' • ' + fmtHe(d);
    modal.querySelectorAll('.alma-time-modal__chip, .alma-time-modal__cal-cell').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-iso') === iso);
    });
    refreshSave();
  }

  function selectWindow(label) {
    selectedWindow = label;
    modal.querySelectorAll('.alma-time-modal__window').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-window') === label);
    });
    refreshSave();
  }

  modal.querySelectorAll('.alma-time-modal__window').forEach(function (btn) {
    btn.addEventListener('click', function () { selectWindow(this.getAttribute('data-window')); });
  });

  function refreshSave() {
    var ok = !!selectedIso && !!selectedWindow;
    saveBtn.disabled = !ok;
    noticeEl.textContent = ok ? '' : 'יש לבחור גם תאריך וגם חלון שעה';
  }

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (!quickWrap.childElementCount) { buildQuick(); buildCalendar(); }
    if (state.window) selectWindow(state.window);
    refreshSave();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  var openBtn = root.querySelector('[data-open-time-modal]');
  if (openBtn) openBtn.addEventListener('click', openModal);
  modal.querySelectorAll('[data-time-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  saveBtn.addEventListener('click', function () {
    if (!selectedIso || !selectedWindow) return;
    var p = selectedIso.split('-');
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    var dateLabel = fmtHe(d) + ' (יום ' + HEB_DAYS[d.getDay()] + ')';
    state.date = dateLabel;
    state.window = selectedWindow;
    root.querySelector('[data-time-date-display]').textContent = dateLabel;
    root.querySelector('[data-time-window-display]').textContent = selectedWindow;
    Promise.all([
      setAttr('תאריך משלוח', dateLabel),
      setAttr('חלון שעה', selectedWindow)
    ]).then(function () {
      var w = root.querySelector('[data-cart-warn]');
      if (w) w.hidden = true;
      closeModal();
    });
  });

  // Checkout button
  var checkoutBtn = root.querySelector('[data-checkout-btn]');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (!state.date || !state.window) {
        var w = root.querySelector('[data-cart-warn]');
        if (w) w.hidden = false;
        openModal();
        return;
      }
      window.location.href = '/checkout';
    });
  }
})();
